// Performance Trend
export const primaryStroke = '#12857A';
export const primaryFill = '#B5EBF3';
export const secondaryStroke = '#9FE7E0';
export const secondaryFill = '#E8E9E9';
export const networkAvgFill = '#8AE2D9';
export const normalFill = '#00A8E1';
export const textFill = '#232F3E';
export enum MERIDIAN_COLORS {
  MERIDIAN_COLOR_BLUE_DARK = '#077398',
  MERIDIAN_COLOR_BLUE_LIGHT = '#86A4AF',
  MERIDIAN_COLOR_RED = '#FF6138',
  MERIDIAN_COLOR_DEFAULT = '#FF6138',
  MERIDIAN_COLOR_LIGHT_GRAY = '#F0F1F2',
  MERIDIAN_COLOR_GRAY_0 = '#FFFFFF',
  MERIDIAN_COLOR_GRAY_800 = '#02080E',
  MERIDIAN_COLOR_GREY_50 = '#F7F6F8',
  MERIDIAN_COLOR_GREY_100 = '#E9EBEF',
  MERIDIAN_COLOR_BLUE_500 = '#00688D',
}
